import React from 'react';

export const ToastSuccess = ({ message }) => (
  <div className="toast toast-success">{message}</div>
);
